// extracted by mini-css-extract-plugin
module.exports = {"container":"card-module--container--3HFco"};